export default "__VITE_ASSET__DS4cDq7z__"